import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PanelList } from '../../../../shared/models/panel-list';
import { CommonService } from '../../../../shared/services/common.service';

@Component({
  selector: 'app-delegation-panel-list',
  templateUrl: './delegation-panel-list.component.html',
  styleUrls: ['./delegation-panel-list.component.scss'],
})
export class DelegationPanelListComponent implements OnInit, OnChanges {

  @Input() myDelegationsData: PanelList = {
    lists: [],
    filters: [],
    sort: [],
    enableFilter: false,
    enableSort: false,
    enableSelection: false,
    isCheckBoxContainsDisable:false
  };
  @Input() showLoader : boolean = false;
  noData: boolean = false;
  @Input() isDelegateToDisplayed = false;
  @Input() isDelegateFromDisplayed = false;
  @Input() isInActiveSelected = false;
  @Output() showInactiveDelegates = new EventEmitter<Event>();
  @Output() selectedDelegates = new EventEmitter();
  isActiveSelected: boolean = !this.isInActiveSelected;

  constructor(private commonService: CommonService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.noData = this.commonService.IsListEmpty(this.myDelegationsData.lists);
    this.isActiveSelected = !this.isInActiveSelected;
  }

  ngOnInit(): void {
  }

  checkboxSelection(event: Event){
    this.showInactiveDelegates.emit(new Event('check-box-selected'));
  }

  openDocument(documentNumber: string, version: string)
  {
    var url = location.origin.concat("/eqms.documentDetails/", documentNumber, ":", version);
    window.open(url, "_blank");
  }

  getSelectedItems(selectedItems:any){
    this.selectedDelegates.emit(selectedItems);
  }

}
